/* DSL Quiz outcome → Klaviyo event */
(function(){
  document.addEventListener("submit", function(e){
    var f = e.target;
    if (!f.matches("[data-quiz]")) return;
    var fd = new FormData(f);
    var profile = {q1: fd.get("q1"), q2: fd.get("q2"), q3: fd.get("q3"), q4: fd.get("q4")};
    if (window.klaviyo && typeof window.klaviyo.track === "function") {
      try { window.klaviyo.track("Skin Quiz Completed", {SkinType: profile.q1, Concern: profile.q2, SPF: profile.q3, RoutineLength: profile.q4}); } catch(err){}
    }
    if (window.DSL_AB) window.DSL_AB.track("quiz_klaviyo", profile);
  }, true);
})();